/**
 * Warstwa API: ODCZYT POWIADOMIEŃ PO OBIEKCIE (2026-09-30, polecenie właściciela B3).
 *
 * „synchronizuj mi powiadomienia i statusy vs to, co mam kliknąć — jak coś kliknę, a było powiadomieniem, to rób jako
 * odczytany i tylko realnie nieodczytane zostaw”.
 *
 * Trasa backendu: `PUT api/notifications/read-for-object` z ciałem `{ rodzaj, id }` (np. `{ rodzaj: "zgloszenie", id: <guid> }`).
 * Serwer oznacza jako przeczytane WSZYSTKIE nieprzeczytane powiadomienia ZALOGOWANEGO konta (userId wyłącznie z tokenu),
 * których link wskazuje ten obiekt, i rozgłasza do wszystkich kart/urządzeń konta `NotificationsReadMany` (lista id)
 * oraz jeden autorytatywny `ReceiveUnreadCount`. Rodzaj spoza białej listy serwera = 400.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do
 * wspólnego `apiService`. Nazwy muszą być unikalne w całej aplikacji (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Oznacz jako przeczytane wszystkie powiadomienia konta o obiekcie (rodzaj, id). */
        markNotificationsReadForObject: (rodzaj, id) =>
            api.put("/notifications/read-for-object", { rodzaj, id: id == null ? id : String(id) }),
    };
}
